var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-container",
        { staticStyle: { height: "100%", border: "1px solid #eee" } },
        [
          _c("el-main", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.askIndex === 0,
                    expression: "askIndex === 0"
                  }
                ],
                staticClass: "blank_content"
              },
              [
                _c("div", { staticClass: "tips" }, [
                  _c("h1", [
                    _vm._v("你好~我是"),
                    _c("span", [_vm._v("AI小智")])
                  ]),
                  _vm._v(" "),
                  _c("h3", [_vm._v("请问，有什么可以帮助您？ ")])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img_bg",
                  attrs: { src: require("../assets/img/ai_bg.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { attrs: { id: "output" } }),
            _vm._v(" "),
            _c("div", { staticClass: "opt_box" }, [
              _c(
                "div",
                { staticClass: "input_box" },
                [
                  _c("el-input", {
                    ref: "input",
                    attrs: {
                      rows: _vm.rows,
                      placeholder:
                        "请输入聊天内容(按下回车发送,需要换行则按下ctrl+回车)",
                      type: "textarea",
                      maxlength: "2000",
                      "show-word-limit": ""
                    },
                    nativeOn: {
                      keydown: function($event) {
                        return _vm.handleKeyDown.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.input,
                      callback: function($$v) {
                        _vm.input = $$v
                      },
                      expression: "input"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.sendLoading,
                        id: "sendBtn"
                      },
                      on: { click: _vm.sendMessage }
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-promotion" }),
                      _vm._v(" 发送\n          ")
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-881e5884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-881e5884","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aiagentBox.vue
// module id = 5Mz+
// module chunks = 129